import { render, staticRenderFns } from "./SubmitButton.vue?vue&type=template&id=5a548b94&"
import script from "./SubmitButton.vue?vue&type=script&lang=js&"
export * from "./SubmitButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports